import { Check, Target, LayoutGrid, Users, Wallet, FlaskConical, Activity } from "lucide-react";
import { Window, Tag, seg } from "./primitives";

const STEPS = [
  { icon: Target, label: "Campaign created", detail: "Objective: Leads · Instant Form" },
  { icon: LayoutGrid, label: "Ad placement", detail: "FB Feed · IG Feed · Reels · Stories" },
  { icon: Users, label: "Audience selected", detail: "Homeowners · Billings, MT + 25 mi" },
  { icon: Wallet, label: "Budget allocated", detail: "Split across ad sets" },
  { icon: FlaskConical, label: "Creative testing", detail: "Ad A vs. Ad B vs. Ad C" },
  { icon: Activity, label: "Performance monitoring", detail: "Daily review & optimization" },
];
const CHART = "M0 70 C 30 66, 50 60, 80 55 S 130 50, 160 38 S 210 30, 240 22 S 280 12, 300 8";

export function StageCampaign({ p }) {
  const draw = seg(p, 0.55, 0.95);
  return (
    <Window title="Ads Manager — Campaign Builder" right={<Tag className="!text-amber-200 !border-amber-300/30">Illustrative example</Tag>}>
      <div className="grid h-full grid-cols-1 gap-3 p-3 sm:grid-cols-[1.1fr_1fr] sm:p-4">
        <ul className="space-y-1.5 sm:space-y-2">
          {STEPS.map(({ icon: Icon, label, detail }, i) => {
            const t = seg(p, i * 0.12, i * 0.12 + 0.12);
            return (
              <li key={label} className="flex items-center gap-3 rounded-lg border px-3 py-1.5 sm:py-2.5 transition-colors duration-300"
                style={{ borderColor: t > 0.99 ? "rgba(0,136,255,0.35)" : "rgba(255,255,255,0.06)", background: t > 0.99 ? "rgba(0,136,255,0.07)" : "transparent", opacity: 0.35 + t * 0.65 }}>
                <span className={`grid h-7 w-7 shrink-0 place-items-center rounded-md ${t > 0.99 ? "bg-electric text-white" : "bg-white/5 text-slate-400"}`}>
                  {t > 0.99 ? <Check className="h-4 w-4" /> : <Icon className="h-3.5 w-3.5" />}
                </span>
                <div className="min-w-0">
                  <p className="text-[13px] font-medium text-white">{label}</p>
                  <p className="truncate text-[11px] text-slate-400">{detail}</p>
                </div>
              </li>
            );
          })}
        </ul>
        <div className="hidden flex-col gap-3 sm:flex">
          <div className="rounded-xl border border-white/[0.07] bg-white/[0.02] p-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-400">Budget split</p>
            {[["Ad set · Homeowners", 50], ["Ad set · Lookalike", 30], ["Ad set · Retargeting", 20]].map(([l, v]) => (
              <div key={l} className="mt-2.5">
                <div className="flex justify-between text-[11px] text-slate-300"><span>{l}</span><span>{v}%</span></div>
                <div className="mt-1 h-1.5 rounded-full bg-white/10"><div className="h-full rounded-full bg-electric" style={{ width: `${v * seg(p, 0.36, 0.5)}%` }} /></div>
              </div>
            ))}
          </div>
          <div className="flex-1 rounded-xl border border-white/[0.07] bg-white/[0.02] p-3">
            <div className="flex items-center justify-between">
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-400">Lead volume trend</p>
              <span className="text-[10px] text-slate-400">sample</span>
            </div>
            <svg viewBox="0 0 300 80" className="mt-3 h-[70%] w-full" preserveAspectRatio="none" aria-hidden="true">
              <defs><linearGradient id="cg" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stopColor="#0088FF" stopOpacity="0.35" /><stop offset="1" stopColor="#0088FF" stopOpacity="0" /></linearGradient></defs>
              <path d={`${CHART} L300 80 L0 80 Z`} fill="url(#cg)" opacity={draw} />
              <path d={CHART} fill="none" stroke="#00E5FF" strokeWidth="2" pathLength="1" strokeDasharray="1" strokeDashoffset={1 - draw} />
            </svg>
          </div>
        </div>
      </div>
    </Window>
  );
}
